/**
 * A simple, select field that allows the current admin user to select a region.
 *
 * Currently used by the InviteUserToFieldwire modal
 */

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import { storage } from "../../../storage";

interface RegionSelectInputProps {
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  required?: boolean;
}

function RegionSelectInput(props: RegionSelectInputProps) {
  return (
    <TextField
      label={props.label}
      name={props.name}
      onChange={props.onChange}
      required={props.required}
      value={props.value}
      select
    >
      {storage.enumerateRegions().map((region) => {
        return (
          <MenuItem key={region} value={region}>
            {region.toUpperCase()}
          </MenuItem>
        );
      })}
    </TextField>
  );
}

export default RegionSelectInput;
